var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDubaiFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 64,
    viewBox: "0 0 97 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.3333 42.25H59.8999L59.518 41.8315L54.518 36.352L54.4269 36.2521L54.2934 36.2738L36.0469 39.2284L41.2314 16.0834L50.3622 4.62152L50.3979 4.57666L50.4106 4.5207L50.9661 2.05495L50.5277 1.843L39.6943 15.2677L39.659 15.3115L39.6458 15.3662L33.2569 41.9416L33.1828 42.25H33.5H59.3333Z",
    fill: "white",
    stroke: "#555960",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1756 2.09593L50.5921 1.52051L50.755 2.32361L58.8105 42.0496L58.8512 42.25H59.0556H63.5H63.8294L63.7408 41.9327L53.1852 4.12451L53.1674 4.06045L53.12 4.01374L51.1756 2.09593Z",
    fill: "white",
    stroke: "#555960",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDubaiFrame);
export default __webpack_public_path__ + "static/media/Dubai Frame.29ba6aa14de6f28b121aa0cb3bd2c42e.svg";
export { ForwardRef as ReactComponent };